import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Routes, Route } from 'react-router-dom'
import { closeAllModals } from './store/modalSlice'

import ModalContainer from './components/modals/ModalContainer'
import PrivateRoute from './PrivateRoute'
import AutoLoginRoute from './AutoLoginRoute'

import {
  SignIn, SignUp, FindPassword, EmailAuth,
  Main, ProfileHome, ModifyProfile,
  SessionalPlan, WeeeklyPlan,
  ReportHome, ReportList, ReportDetail,
  WriteReport, ModifyReport,
  DailyLog, StudySetting,
  MainContents, PlannerHome, OpenSourceLicenses, PrivacyPolicy
} from './pages'

function AppContent() {
  const dispatch = useDispatch()

  useEffect(() => {
    const onPopState = () => {
      dispatch(closeAllModals())
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [dispatch])

  return (
    <>
      <Routes>
        <Route path='/' element={<AutoLoginRoute />} />
        <Route path='/oss-licenses' element={<OpenSourceLicenses />}/>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/main' element={<PrivateRoute component={<Main />} />}>
          <Route index element={<MainContents />} />
          <Route path='modify-profile' element={<ProfileHome />}>
            <Route index element={<ModifyProfile />} />
          </Route>
          <Route path='planner' element={<PlannerHome />}>
            <Route path='sessional-plan' element={<SessionalPlan />} />
            <Route path='sessional-plan/:sessionalPlanId/weekly-plan' element={<WeeeklyPlan />} />
          </Route>
          <Route path='report' element={<ReportHome />}>
            <Route path='list' element={<ReportList />} />
            <Route path=':reportId' element={<ReportDetail />} />
            <Route path='write' element={<WriteReport />} />
            <Route path=':reportId/modify' element={<ModifyReport />} />
          </Route>
          <Route path='daily-log/list' element={<DailyLog />} />
          <Route path='study-setting' element={<StudySetting />} />
        </Route>
        <Route path='/sign-in' element={<SignIn />} />
        <Route path='/sign-up' element={<SignUp />} />
        <Route path='/email-auth' element={<EmailAuth />} />
        <Route path='/find-pw' element={<FindPassword />} />
      </Routes>
      <ModalContainer />
    </>
  )
}

export default AppContent
